
import React from 'react';

interface BaseRunnersControlProps {
  baseRunners: boolean[];
  onBaseRunnerChange: (index: number) => void;
}

export function BaseRunnersControl({
  baseRunners,
  onBaseRunnerChange,
}: BaseRunnersControlProps) {
  return (
    <div className="bg-white/5 rounded-lg p-4">
      <h4 className="text-lg sm:text-xl font-semibold text-white mb-4">Base Runners</h4>
      <div className="flex flex-col items-center">
        <div className="relative aspect-[5/3] w-full max-w-[300px]">
          {/* Top Triangle (2nd Base) */}
          <button
            onClick={() => onBaseRunnerChange(1)}
            className={`absolute left-1/2 -translate-x-1/2 top-0 w-16 h-16
              ${baseRunners[1] ? 'bg-gradient-to-br from-[#FFB800] to-[#FF8A00]' : 'border-4 border-white'} 
              transform rotate-45 cursor-pointer transition-colors hover:border-yellow-400`}
          />
          {/* Bottom Left Triangle (3rd Base) */}
          <button
            onClick={() => onBaseRunnerChange(2)}
            className={`absolute left-4 translate-y-[75%] w-16 h-16
              ${baseRunners[2] ? 'bg-gradient-to-br from-[#FFB800] to-[#FF8A00]' : 'border-4 border-white'} 
              transform rotate-45 cursor-pointer transition-colors hover:border-yellow-400`}
          />
          {/* Bottom Right Triangle (1st Base) */}
          <button
            onClick={() => onBaseRunnerChange(0)}
            className={`absolute right-4 translate-y-[75%] w-16 h-16
              ${baseRunners[0] ? 'bg-gradient-to-br from-[#FFB800] to-[#FF8A00]' : 'border-4 border-white'} 
              transform rotate-45 cursor-pointer transition-colors hover:border-yellow-400`}
          />
        </div>
      </div>
    </div>
  );
}
